import { axiosServices } from "./axiosServices";

export const grnServices = { getGRNListing, getGRNProductList, takeAction };

function getGRNListing(param) {
    return axiosServices.getAxios(`/v1/common/grns${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getGRNProductList(grnId, param) {
    return axiosServices.getAxios(`/v1/common/grns/${grnId}/products${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function takeAction(bodyData) {
    return axiosServices.postAxios('/v1/common/grns/take-action', bodyData).then(
        res => { 
            // console.log(res);
            return res;
    });
}
